const valueBoundary = {
  en: "Your kundali and first chart-grounded answer are free.",
  hi: "Aapki kundali aur pehla chart-grounded answer free hai.",
};

const paidBoundary = {
  en: "A paid continuation may follow; its price and duration appear before payment.",
  hi: "Uske baad paid continuation aa sakta hai; price aur duration payment se pehle dikhega.",
};

const phonePurpose = {
  en: "A mobile number is required to save this private reading so you can reopen it.",
  hi: "Private reading save karke phir kholne ke liye mobile number required hai.",
};

const consentBoundary = {
  en: "Required mobile capture does not opt you into marketing; recurring messages need a separate opt-in.",
  hi: "Required mobile capture marketing opt-in nahi hai; recurring messages ke liye alag opt-in chahiye.",
};

const unknownTimeBoundary = {
  en: "No exact birth time? You can still receive a reduced, time-insensitive reading from your birth date and place. We will not claim an exact Lagna, houses, divisional charts, or Dasha timing without an exact time.",
  hi: "Exact birth time nahi pata? Birth date aur place se reduced, time-insensitive reading mil sakti hai. Exact time ke bina hum exact Lagna, houses, divisional charts ya Dasha timing ka claim nahi karte.",
};

export const AI_ASTROLOGER_ONBOARDING_CONTRACT = {
  hero: {
    eyebrow: "AI Vedic Astrology Consultation",
    title: "Free AI Astrologer Chat: Why Does This Keep Happening?",
    body: "Ask about marriage, career, a dosha or your birth chart. The AI Jyotishi explains the calculated chart factors your birth details support, the traditional interpretation and its limits.",
    visualTitle: "See how your chart becomes an answer",
    visualBody:
      "With exact birth time, the engine calculates houses and timing. Without it, the reading stays time-insensitive. Your AI Jyotishi explains supported patterns and a practical upay.",
    cardEyebrow: "Your AI Jyotishi",
    cardTitle: "What would you like to understand?",
    cardBody:
      "Choose a concern or ask anything. We will explain the relevant chart factors without treating them as a guaranteed cause.",
    signals: ["No app download", "Engine-calculated chart", "First answer free"],
    methodProof: {
      engine: "Chart calculated with Swiss Ephemeris · Lahiri Ayanamsa",
      reviewer: "Jyotish method reviewed by Pandit Kuldeep Shastri",
      reviewerHref: "/reviewer/pandit-kuldeep-shastri/",
    },
  },
  concerns: {
    legend: "What is on your mind right now?",
    helper: "Optional — choose one, or skip.",
    changeLabel: "Choose a different concern",
    skipLabel: "Skip — ask anything",
    skipTitle: "Ask anything",
    skipLens: "No preset topic · ask after your chart is ready",
    selectedAnnouncement: "Concern selected. Name field ready.",
    skippedAnnouncement:
      "No preset concern. Name field ready; you can ask anything after your chart is ready.",
    options: [
      {
        key: "marriage_delay",
        title: "Marriage keeps getting delayed",
        prompt: "Which house, dasha, or dosha is affecting my marriage timing?",
        seoIntent: "chart_report",
        concern: "marriage",
        lens: "7th house · dasha",
      },
      {
        key: "career_stuck",
        title: "Career growth stays blocked",
        prompt: "What can my chart say about career, and what remains uncertain?",
        seoIntent: "chart_report",
        concern: "career",
        lens: "10th house · career",
      },
      {
        key: "money_drain",
        title: "Money comes, then disappears",
        prompt: "Which chart factor is affecting my ability to keep and grow money?",
        seoIntent: "chart_report",
        concern: "wealth",
        lens: "2nd and 11th houses",
      },
      {
        key: "dosha_peace",
        title: "Dosha, Rahu-Ketu or peace of mind",
        prompt:
          "Which dosha or dasha is active in my chart, and what classical upay is recommended?",
        seoIntent: "chart_report",
        concern: "dosha",
        lens: "dasha · remedies",
      },
    ],
  },
  trust: { valueBoundary, paidBoundary, phonePurpose, consentBoundary, unknownTimeBoundary },
} as const;

const contract = AI_ASTROLOGER_ONBOARDING_CONTRACT;

export const AI_ASTROLOGER_TRUST_COPY = {
  en: {
    reassurance: `${valueBoundary.en} ${paidBoundary.en}`,
    savedNote: `${phonePurpose.en} ${consentBoundary.en}`,
    freeFaqAnswer: `${valueBoundary.en} There is no running per-minute meter. ${paidBoundary.en}`,
    detailsFaqAnswer: `Enter your name, birth date, birth place, and a valid mobile number. ${unknownTimeBoundary.en} ${phonePurpose.en} ${consentBoundary.en}`,
    // The boundary sentences alone are a strict subset of `detailsFaqAnswer`
    // above, so rendering both put an intra-page near-duplicate pair on the
    // page (J=0.57 against the 0.55 ceiling) and failed the live
    // indexable-value gate. The disclosure is load-bearing and must stay
    // verbatim in BOTH answers (rules 25/29 + AIAstrologerTrustCopy.test.ts);
    // what this answer adds is the other half a seeker actually asks for —
    // what the reduced reading still contains.
    unknownTimeFaqAnswer: `${unknownTimeBoundary.en} Moon sign and nakshatra can change during the birth date; a date alone does not establish a precise Vimshottari schedule. Ask which factors remain stable across the day and which need your birth record. If you later find a reliable time, recalculate before exploring houses or timing.`,
    availability: `Ishvaram is available instantly. ${valueBoundary.en} ${paidBoundary.en}`,
    freeSectionBoundary: `${valueBoundary.en} ${paidBoundary.en}`,
    comparisonCost: "Free kundali and first answer; clearly priced continuation may follow",
    startRequirements: "Optional concern, birth details, and required mobile",
    formTitle: "Start your free AI reading",
    formBody: "Enter birth details once. No exact time? Get a reduced, time-insensitive reading.",
    formReassurance:
      "First chart-grounded answer free; any paid continuation shows price and duration first. No exact birth time? You get a reduced, time-insensitive reading.",
  },
  hi: {
    reassurance: `${valueBoundary.hi} ${paidBoundary.hi}`,
    savedNote: `${phonePurpose.hi} ${consentBoundary.hi}`,
    formBody: "Birth details ek baar bharein. Exact time nahi? Reading time-insensitive rahegi.",
    formReassurance:
      "Pehla chart-grounded answer free hai; paid continuation ka price aur duration pehle dikhega. Exact birth time nahi? Reading reduced aur time-insensitive rahegi.",
  },
  schemaDescription: `${valueBoundary.en} ${paidBoundary.en}`,
  offerName: valueBoundary.en,
  hero: contract.hero,
} as const;
